/*
 * @Descripttion:
 * @Author: 01387189
 * @Date: 2021-07-14 14:30:09
 * @LastEditors: 01387189
 * @LastEditTime: 2021-07-14 15:09:51
 */
// 交易
const notProduction = [
  {
    path: "/payment/subscriptions",
    name: "subscriptions",
    meta: {
      title: "产品购买-顺丰科技数字商店",
    },
    component: () =>
      import(/* webpackChunkName:'home' */ "@/pages/payment/Subscriptions"),
  },
  {
    path: "/payment/confirm",
    name: "confirm",
    meta: {
      title: "订单确认-顺丰科技数字商店",
    },
    component: () =>
      import(/* webpackChunkName:'home' */ "@/pages/payment/OrderConfirm"),
  },
  {
    path: "/payment/checkstand",
    name: "checkstand",
    meta: {
      title: "收银台-顺丰科技数字商店",
    },
    component: () =>
      import(/* webpackChunkName:'home' */ "@/pages/payment/Checkstand"),
  },
];

export default notProduction;
